import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { StateService } from 'src/app/services/state.service';

@Component({
  selector: 'items-list',
  templateUrl: './items-list.component.html',
  styleUrls: ['./items-list.component.css']
})
export class ItemsListComponent implements OnInit, OnDestroy {

  @Input() data: Array<any> = [];
  @Output() itemClickedEvent = new EventEmitter<any>();
  @Output() deleteItemEvent = new EventEmitter<any>();

  constructor(
    public stateService: StateService
  ) { }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
  }

  deleteItem(event: any, item: any) {
    event.stopPropagation();
    this.deleteItemEvent.emit(item);
  }

  itemClicked(item: any) {
    this.itemClickedEvent.emit(item);
  }
}
